import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { BsPlus } from "react-icons/bs";
import { IoClose } from "react-icons/io5";

import FilePreview from "../../../../../../../common/filePreview";
import Tooltip from "./tooltip";

import "swiper/css";
import "swiper/css/pagination";

const MediaItem = ({ item, onDelete, setIsDetail }) => (
  <div className="box">
    <FilePreview item={item} setIsDetail={setIsDetail} />
    <button onClick={() => onDelete(item)}>
      <IoClose />
    </button>
  </div>
);

const UploadButton = ({ accept, onClick, onChange }) => (
  <label>
    <div className="icon">
      <BsPlus />
    </div>
    <input type="file" accept={accept} multiple onClick={onClick} onChange={onChange} />
  </label>
);

const MediaUpload = ({
  label = "",
  max = 5,
  keyName,
  media = [],
  tooltip,
  setIsDetail = null,
  handleAddImage,
  handleDeleteImage,
  accept = "image/*",
  isSlide = false,
}) => {
  const scrollRef = useRef();

  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = x - startX;
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };
  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };

  const onClickFile = (e) => {
    if (media.length >= max) {
      e.preventDefault();
      toast.error(`이미지는 최대 ${max}장까지 첨부 가능합니다.`);
    }
  };

  const renderItems = () =>
    media.map((item) => (
      <MediaItem key={item.id} item={item} onDelete={handleDeleteImage} setIsDetail={setIsDetail} />
    ));

  return (
    <li className={keyName}>
      {label &&
        (tooltip ? (
          <Tooltip label={label} tooltip={tooltip} />
        ) : (
          <span className="tit">{label}</span>
        ))}
      <div
        className="cont"
        ref={scrollRef}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseLeave}>
        {isSlide ? (
          <div className="banners">
            {renderItems()}
            <UploadButton accept={accept} onClick={onClickFile} onChange={handleAddImage} />
          </div>
        ) : (
          <>
            {renderItems()}
            <UploadButton accept={accept} onClick={onClickFile} onChange={handleAddImage} />
          </>
        )}
      </div>
    </li>
  );
};

export default MediaUpload;
